import {fromJS} from 'immutable';

import {INCREMENT_PENDING, DECREMENT_PENDING} from '../containers/actions';
import * as actions from './actions';

export default (state = fromJS({}), action) => {
    if (state.get('errors') === undefined) {
        state = state.set('errors', fromJS({}));
    }
    if (state.get('pending') === undefined) {
        state = state.set('pending', 0);
    }
    if (state.get('content') === undefined) {
        state = state.set('content', fromJS({readonly: true}));
    }
    //console.log("state.get('content')2:",state.get('content'),state.get('content').get);
    if (state.get('content').get == undefined || state.get('content').get('readonly') === undefined) {
        state = state.setIn(['content', 'readonly'], true);
    }
    if (action.elementId === state.get('elementId')) {
        switch (action.type) {
        case actions.SET_URI:
            state = state.merge({
                content: {uri: action.uri},
            });
            break;

        case actions.SET_CONTENT:
            state = state.set('content', fromJS(action.content));
            break;

        case actions.SET_ERRORS:
            state = state.set('errors', fromJS(action.errors));
            break;
        }
    }
    else {
        switch (action.type) {
        case INCREMENT_PENDING:
            state = state.set('pending', state.get('pending') + 1);
            break;

        case DECREMENT_PENDING:
            state = state.set('pending', state.get('pending') - 1);
            break;
        }
    }
    return state;
};
